module.exports = __webpack_public_path__ + "media/images/dashboards/probe-97977bce5ae5ca2d7ca9b53bd239344c.png";